<!-- src/views/pages/administration/reports/muster-roll-report.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="mb-2">
            <div class="dropdown">
              <a
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportExcel"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportCsv"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-csv me-1"></i>Export as CSV
                  </a>
                </li>
                <li>
                  <a
                    class="dropdown-item rounded-1"
                    href="javascript:void(0);"
                    @click.prevent="exportPdf"
                    v-can="'Reports.Export'"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Filters + KPI -->
      <div class="row mb-3">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <h5 class="mb-3">Filters</h5>
              <div class="mb-3">
                <label class="form-label">Payroll Frequency</label>
                <select class="form-select" v-model="filters.frequency" @change="onPeriodChange">
                  <option value="monthly">Monthly</option>
                  <option value="weekly">Weekly</option>
                  <option value="fortnightly">Fortnightly</option>
                  <option value="daily">Daily</option>
                </select>
              </div>
              <div class="mb-3" v-if="filters.frequency === 'monthly'">
                <label class="form-label">Payroll Period</label>
                <input type="month" class="form-control" v-model="filters.period" @change="onPeriodChange" />
              </div>
              <div class="mb-3" v-else>
                <label class="form-label">Period Start</label>
                <input type="date" class="form-control" v-model="filters.period_start" @change="onPeriodChange" />
              </div>
              <div class="mb-3" v-if="filters.frequency !== 'monthly'">
                <label class="form-label">Period End</label>
                <input type="date" class="form-control" v-model="filters.period_end" @change="onPeriodChange" />
              </div>
              <!-- Reserved space for department / employee filters later -->
            </div>
          </div>
        </div>

        <div class="col-xl-8">
          <div class="row">
            <div
              v-for="c in kpiCards"
              :key="c.title"
              class="col-md-6 col-lg-4 d-flex"
            >
              <div class="card flex-fill dq-stat-card">
                <div class="card-body">
                  <div
                    class="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2"
                  >
                    <div>
                      <span class="fs-14 fw-normal text-truncate mb-1">{{
                        c.title
                      }}</span>
                      <h5 v-if="c.isMoney">
                        {{ currency }}
                        {{
                          Number(c.value).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                          })
                        }}
                      </h5>
                      <h5 v-else>
                        {{ Number(c.value).toLocaleString() }}
                      </h5>
                    </div>
                    <a
                      href="javascript:void(0);"
                      class="avatar avatar-md avatar-rounded"
                      :class="`bg-transparent-${c.cls} border border-${c.cls}`"
                    >
                      <span :class="`text-${c.cls}`">
                        <i class="ti ti-clipboard-list"></i>
                      </span>
                    </a>
                  </div>
                  <p class="fs-12 text-muted mb-0">Based on selected period</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /row -->

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Muster Roll</h5>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <MusterRollReportTable
              :rows="store.musterRows"
              :loading="store.musterLoading"
              :currency="currency"
              :total="store.musterTotal"
              :page-size="store.musterPageSize"
              :current="store.musterCurrent"
              @change="onTableChange"
            />
          </div>
        </div>
      </div>

      <!-- Attendance Summary -->
      <div class="card mt-3">
        <div class="card-header">
          <h5 class="mb-0">Attendance Summary</h5>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4 col-lg-3" v-for="item in attendanceSummaryItems" :key="item.label">
              <div class="border rounded p-3 h-100">
                <div class="fs-13 text-muted mb-1">{{ item.label }}</div>
                <div class="fs-16 fw-semibold">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, computed, onMounted } from "vue";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import MusterRollReportTable from "./muster-roll-report-table.vue";
import { currentPayrollYYYYMM, suggestPeriodWindow, endDateForFrequency } from "@/utils/payrollPeriodHelpers";

const title = "Muster Roll";
const text = "Administration";
const text1 = "Muster Roll";

const store = useEmployeeSalaryStore();

const suggested = suggestPeriodWindow("monthly");
const filters = reactive({
  frequency: "monthly",
  period: currentPayrollYYYYMM() || suggested.period,
  period_start: suggested.periodStart || "",
  period_end: suggested.periodEnd || "",
  page: 1,
  per_page: 25,
});

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function fetchReport() {
  const params = buildParams();
  if (!params) return;
  await store.fetchMusterRollReport({
    ...params,
    page: filters.page,
    per_page: filters.per_page,
    force: true,
  });
}

function onPeriodChange() {
  if (filters.frequency !== "monthly" && filters.period_start) {
    filters.period_end =
      endDateForFrequency(filters.frequency, filters.period_start) ||
      filters.period_end;
  }
  filters.page = 1;
  fetchReport();
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetchReport();
}

function exportCsv() {
  const params = buildParams();
  if (!params) return;
  store.exportMusterRollReportCSV(params);
}

function exportExcel() {
  const params = buildParams();
  if (!params) return;
  store.exportMusterRollReportExcel(params);
}

function exportPdf() {
  const params = buildParams();
  if (!params) return;
  store.exportMusterRollReportPDF(params);
}

function buildParams() {
  if (filters.frequency === "monthly") {
    if (!filters.period) return null;
    return {
      frequency: "monthly",
      period: filters.period,
    };
  }

  if (!filters.period_start || !filters.period_end) return null;
  return {
    frequency: filters.frequency,
    period_start: filters.period_start,
    period_end: filters.period_end,
  };
}

const summary = computed(() => store.musterSummary || {});
const currency = computed(() => summary.value.currency || "KES");

const attendance = computed(() => summary.value.attendance_summary || {});

const kpiCards = computed(() => [
  {
    title: "Employees",
    value: summary.value.employee_count || 0,
    isMoney: false,
    cls: "primary",
  },
  {
    title: "Days Present",
    value: summary.value.total_present_days || attendance.value.total_present_days || 0,
    isMoney: false,
    cls: "success",
  },
  {
    title: "Days Absent",
    value: summary.value.total_absent_days || attendance.value.total_absent_days || 0,
    isMoney: false,
    cls: "danger",
  },
  {
    title: "Total Gross",
    value: summary.value.total_gross || 0,
    isMoney: true,
    cls: "info",
  },
  {
    title: "Total Deductions",
    value: summary.value.total_deductions || 0,
    isMoney: true,
    cls: "warning",
  },
  {
    title: "Total Net",
    value: summary.value.total_net || 0,
    isMoney: true,
    cls: "primary",
  },
]);

const attendanceSummaryItems = computed(() => {
  const att = attendance.value;
  return [
    { label: "Employees", value: Number(att.employees ?? summary.value.employee_count ?? 0).toLocaleString() },
    { label: "Total Days Present", value: Number(att.total_present_days ?? summary.value.total_present_days ?? 0).toLocaleString() },
    { label: "Total Days Absent", value: Number(att.total_absent_days ?? summary.value.total_absent_days ?? 0).toLocaleString() },
    {
      label: "Avg Days Present / Employee",
      value: Number(att.average_present_days ?? 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    },
    { label: "Employees with Absence", value: Number(att.employees_with_absence ?? 0).toLocaleString() },
    { label: "Period From", value: summary.value.from || "—" },
    { label: "Period To", value: summary.value.to || "—" },
  ];
});

onMounted(() => {
  fetchReport();
});
</script>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-right: 0 !important;
  }

  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle,
  .dq-page-actions .form-control {
    width: 100%;
  }

  .dq-stat-card .card-body {
    padding: 1rem;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>


